import React, { useState } from "react";
import { Button, message } from "antd";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { useBulletinSectionService } from "../../services";

export default function ReorderControl({
  section,
  sectionIdx,
  sections,
  setSections,
  reloadSections = () => Promise.resolve(),
  bulletinId,
}) {
  const [isMoving, setIsMoving] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const { service: sectionService } = useBulletinSectionService();

  const handleReorder = async (newOrder) => {
    // Validate the move
    if (
      newOrder < 0 ||
      newOrder >= sections.length ||
      newOrder === sectionIdx
    ) {
      return;
    }

    // Only move sections that have been saved (have real IDs)
    if (!section.id || typeof section.id !== "number") {
      messageApi.open({
        type: "warning",
        content: "Please save the section before reordering",
      });
      return;
    }

    if (isMoving) return;
    setIsMoving(true);

    const hideLoading = messageApi.open({
      type: "loading",
      content: "Reordering section...",
      duration: 0,
    });

    try {
      // Create updated sections array with new order
      const updatedSections = [...sections];
      updatedSections.splice(sectionIdx, 1);
      updatedSections.splice(newOrder, 0, section);

      // Filter out only sections that have real IDs and update their display_order
      const sectionsToUpdate = updatedSections
        .filter((sec) => sec.id && typeof sec.id === "number")
        .map((sec, index) => ({ ...sec, display_order: index }));

      // Update display_order in backend for all affected sections
      const updatePromises = sectionsToUpdate.map((sec) =>
        sectionService.updateSection(bulletinId, sec.id, {
          display_order: sec.display_order,
        })
      );

      await Promise.all(updatePromises);

      // Update local state
      setSections(updatedSections);

      hideLoading();
      messageApi.open({
        type: "success",
        content: "Section reordered successfully!",
      });

      // // Reload sections after a short delay to ensure consistency
      // setTimeout(() => {
      //   reloadSections();
      // }, 500);
    } catch (error) {
      console.error("Failed to reorder section:", error);
      hideLoading();
      messageApi.open({
        type: "error",
        content: "Failed to reorder section. Please try again.",
      });
    } finally {
      setIsMoving(false);
    }
  };

  return (
    <>
      {contextHolder}
      <div className="reorder-control">
        <Button
          type="text"
          onClick={() => handleReorder(sectionIdx - 1)}
          disabled={sectionIdx === 0 || isMoving}
          loading={isMoving && sectionIdx > 0}
        >
          <UpOutlined />
        </Button>
        <Button
          type="text"
          onClick={() => handleReorder(sectionIdx + 1)}
          disabled={sectionIdx === sections.length - 1 || isMoving}
          loading={isMoving && sectionIdx < sections.length - 1}
        >
          <DownOutlined />
        </Button>
      </div>
    </>
  );
}
